import { ComponentType } from '@interfaces/component-type';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Checkbox, Form, Input, InputNumber, Radio, Table } from 'antd';
import React, { Component } from 'react';

const { TextArea } = Input;
const RadioGroup = Radio.Group;

interface ITextInstructionComponentPropType {
  form: any;
  inputTitleValue: string;
  inputDescriptionValue: string;
  requiredCheckedValue?: boolean;
  repeatCheckedValue?: boolean;
  onInputInstructionChange: Function;
  titleComponent: string;
  descriptionComponent: string;
  exampleDescriptionComponent?: string;
  checkboxtTaskPerform?: boolean;
  checkboxtTaskMarkDescription?: boolean;
  titleCheckboxtTaskPerform?: string;
  titleCheckboxMarkDescription?: string;
  visibleDescription: boolean;
  radioListNewOrExisting?: boolean;
  ItemList?: string;
  onChangeRadioNewOrExistingList?: any;
  radioOnlyOneOrMultipleItemList?: boolean;
  titleRadioOnlyOneItemList?: string;
  titleRadioMultipleItemList?: string;
  conditionsTaskComponents: boolean;
  valueRadioSelect?: string;
  tableShowing?: any;
  columnsTable?: any;
  dataTable?: any;
  onChangeRequiredCheckbox?: any;
  onChangeRepeatCheckbox?: Function;
  onChangeDescription: Function;
  onChangeProblem?: any;
  onChangeRadioOnlyItemList?: any;
  onChangeRadioMultipleItemList?: any;
  problemValue?: boolean;
  radioOnlyItemValue?: string;
  radioMultipleItemValue?: string;
  valueRadioItemList?: boolean;
  gotoSectonOption?: boolean;
  valueRadioGoTo?: boolean;
  onChangeGoToRepeat?: any;
  onChangeRepeatGoToMin?: any;
  onChangeRepeatGoToMax?: any;
  valueRepeatGoToMax?: number;
  valueRepeatGoToMin?: number;
  isSample?: boolean;
  onChangedSample?: any;
  onChangeMultipleMin?: any;
  onChangeMultipleMax?: any;
  valueMultipleMax?: number;
  valueMultipleMin?: number;
  gotoitems?: number;
  onChangeRepeatMin?: any;
  onChangeRepeatMax?: any;
  valueRepeatMax?: number;
  valueRepeatMin?: number;
  isSingleline?: boolean;
  singlelineValue?: boolean;
  onChangedSingleLine?: any;
  titleRepeatMin?: string;
  titleRepeatMax?: string;
  speech?: boolean;
  onChangeSpeech?: any;
};

interface ITextInstructionComponentStateType {
};

const FormItem = Form.Item;
export default class TextIntructionComponent extends React.Component<ITextInstructionComponentPropType, ITextInstructionComponentStateType> {

  constructor(props: ITextInstructionComponentPropType) {
    super(props);
    this.state = {
      form: undefined
    };
  }

  handleSubmit = (e: any) => {
    e.preventDefault();
    this.props.form.validateFields((err: any, values: any) => {
      if (!err) {
        console.log('Received values of form: ', values);
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
    };
    const {
      inputTitleValue,
      onInputInstructionChange,
      titleComponent,
      descriptionComponent,
      exampleDescriptionComponent,
      checkboxtTaskPerform,
      titleCheckboxtTaskPerform,
      checkboxtTaskMarkDescription,
      titleCheckboxMarkDescription,
      visibleDescription,
      radioListNewOrExisting,
      ItemList,
      onChangeRadioNewOrExistingList,
      radioOnlyOneOrMultipleItemList,
      titleRadioOnlyOneItemList,
      titleRadioMultipleItemList,
      conditionsTaskComponents,
      requiredCheckedValue,
      repeatCheckedValue,
      valueRadioSelect,
      tableShowing,
      columnsTable,
      inputDescriptionValue,
      dataTable,
      onChangeRequiredCheckbox,
      onChangeRepeatCheckbox,
      onChangeDescription,
      onChangeProblem,
      problemValue,
      onChangeRadioMultipleItemList,
      gotoSectonOption,
      onChangeGoToRepeat
    } = this.props;
    return (
      <TextStyle>
        <Form onSubmit={this.handleSubmit}>
          <h3>{titleComponent}</h3>
          <p> {descriptionComponent} </p>
          <p > {exampleDescriptionComponent}</p>
          {tableShowing &&
            <Table style={{ marginBottom: ' 2rem' }} columns={columnsTable} dataSource={dataTable} bordered pagination={false} />
          }
          {(radioListNewOrExisting === true) &&
            <div className="radio-new-or-existing-style" >
              <RadioGroup defaultValue={valueRadioSelect} onChange={onChangeRadioNewOrExistingList} >
                <Radio style={radioStyle} value={ComponentType.SELECT}>{I18n.l("formflow.components.selectComponent.newSelectComponent")}</Radio>
                <Radio className="radio-item-style" style={radioStyle} value={ComponentType.SELECTAPI}>{I18n.l("formflow.components.selectComponent.existingSelectComponent")}</Radio>
              </RadioGroup >
              <DividerBorder />
            </div>

          }
          {(visibleDescription === true || ItemList !== undefined) &&
            <div>
              <FormItem>
                {getFieldDecorator('note', {
                  rules: [
                    { required: true, message: I18n.l("formflow.labels.requiredField") },
                    {
                      min: 3, message: I18n.l('formflow.labels.validationToShort')
                    },
                  ],
                })(<div>
                  <p >{I18n.l("formflow.components.instructionTitle")}</p>
                  <div className="input-style" >
                    <Input
                      defaultValue={inputTitleValue}
                      className={inputTitleValue.length === 120 ? "apply-shake" : ''}
                      maxLength={120}
                      placeholder={I18n.l("form.placeholders.textComponentMulti")}
                      onChange={onInputInstructionChange()}
                    />
                  </div>
                </div>)}
              </FormItem>
              <div className="input-style" >
                <p style={{ float: 'right' }} className={inputTitleValue.length < 120 ? "count-input" : "count-input-red"}>
                  {inputTitleValue.length !== 0 ? inputTitleValue.length + '/ 120' : '0/ 120'}
                </p>
              </div>
              <TextAreaStyle>
                <p className="description-aditional-text-style" >{I18n.l("formflow.components.descriptionAditional")}</p>
                <TextArea
                  onChange={onChangeDescription()}
                  defaultValue={inputDescriptionValue}
                  rows={4}
                  className="textarea-style"
                  placeholder={I18n.l("formflow.components.descriptionPlaceholder")}
                />
              </TextAreaStyle>
              {gotoSectonOption === true &&
                <React.Fragment>
                  <div>
                    <DividerBorder />
                    <RadioGroup onChange={onChangeGoToRepeat} defaultValue={this.props.valueRadioGoTo}>
                      <Radio className="content-conditions-goto-components" style={radioStyle} value={true}>{I18n.l("formflow.component.gotoSingle")}</Radio>
                      <Radio className="content-conditions-goto-components" style={radioStyle} value={false}>{I18n.l("formflow.component.gotoMulti")}</Radio>
                    </RadioGroup >
                  </div>
                </React.Fragment>
              }
              {(conditionsTaskComponents === true) &&
                <div>
                  <DividerSlimBorder />
                  {/* SINGLELINE */}
                  {this.props.isSingleline &&
                    <div>
                      <Checkbox onChange={this.props.onChangedSingleLine} defaultChecked={this.props.singlelineValue} >{I18n.l("formflow.components.singleLine")}</Checkbox>
                    </div>
                  }
                  <div>
                    {/* REQUIRED */}
                    <Checkbox className="content-conditions-task-components" onChange={onChangeRequiredCheckbox()} defaultChecked={requiredCheckedValue} >{I18n.l("formflow.components.requiredTask")}</Checkbox>
                  </div>
                  {/* REPEAT GOTO */}
                  {(gotoSectonOption && this.props.valueRadioGoTo && !this.props.isSample) &&
                    <React.Fragment>
                      <div className="text-checkbox-validation" >
                        {I18n.l("formflow.component.gotoSingle.minRepeat")}
                        <InputNumber min={0} max={this.props.valueRepeatGoToMax} onChange={this.props.onChangeRepeatGoToMin} defaultValue={this.props.valueRepeatGoToMin} placeholder="n°" className="text-input-validation" />
                      </div>
                      <div className="text-checkbox-validation" >
                        {I18n.l("formflow.component.gotoSingle.maxRepeat")}
                        <InputNumber min={this.props.valueRepeatGoToMin} onChange={this.props.onChangeRepeatGoToMax} defaultValue={this.props.valueRepeatGoToMax} placeholder="n°" className="text-input-validation" />
                      </div>
                    </React.Fragment>
                  }
                  {/* REPEAT GOTO MULTIPLE */}
                  {(gotoSectonOption && !this.props.valueRadioGoTo && !this.props.isSample) &&
                    <React.Fragment>
                      <div className="text-checkbox-validation" >
                        {I18n.l("formflow.component.gotoSingle.minMultiple")}
                        <InputNumber min={0} max={this.props.valueMultipleMax} onChange={this.props.onChangeMultipleMin} defaultValue={this.props.valueMultipleMin} placeholder="n°" className="text-input-validation" />
                      </div>
                      <div className="text-checkbox-validation" >
                        {I18n.l("formflow.component.gotoSingle.maxMultiple")}
                        <InputNumber min={this.props.valueMultipleMin} max={this.props.gotoitems} onChange={this.props.onChangeMultipleMax} defaultValue={this.props.valueMultipleMax} placeholder="n°" className="text-input-validation" />
                      </div>
                    </React.Fragment>
                  }
                  {(checkboxtTaskPerform === true && onChangeRepeatCheckbox !== undefined) &&
                    <React.Fragment>
                      <div className="content-conditions-task-components">
                        <Checkbox onChange={onChangeRepeatCheckbox()} defaultChecked={repeatCheckedValue} >{titleCheckboxtTaskPerform}</Checkbox>
                      </div>
                      {/* REPEAT DEFAULT */}
                      {(repeatCheckedValue) &&
                        <React.Fragment>
                          <div className="text-checkbox-validation" >
                            {this.props.titleRepeatMin}
                            <InputNumber min={this.props.requiredCheckedValue ? 1 : 0} max={this.props.valueRepeatMax} onChange={this.props.onChangeRepeatMin} defaultValue={this.props.valueRepeatMin} placeholder="n°" className="text-input-validation" />
                          </div>
                          <div className="text-checkbox-validation" >
                            {this.props.titleRepeatMax}
                            <InputNumber min={this.props.valueRepeatMin} onChange={this.props.onChangeRepeatMax} defaultValue={this.props.valueRepeatMax} placeholder="n°" className="text-input-validation" />
                          </div>
                        </React.Fragment>
                      }
                    </React.Fragment>
                  }
                  {(checkboxtTaskMarkDescription === true) &&
                    <div className="content-conditions-task-components">
                      <Checkbox onChange={onChangeProblem()} defaultChecked={problemValue}>{titleCheckboxMarkDescription}</Checkbox>
                    </div>
                  }
                  {this.props.speech !== undefined &&
                    <Checkbox
                      className="content-conditions-task-components"
                      defaultChecked={this.props.speech}
                      onChange={this.props.onChangeSpeech}
                    >
                      {I18n.l("formflow.components.speech")}
                    </Checkbox>
                  }
                  {(radioOnlyOneOrMultipleItemList === true) &&
                    <div>
                      <RadioGroup onChange={onChangeRadioMultipleItemList} defaultValue={this.props.valueRadioItemList}>
                        <Radio className="content-conditions-task-components" style={radioStyle} value={false}>{titleRadioOnlyOneItemList}</Radio>
                        <Radio className="content-conditions-task-components" style={radioStyle} value={true}>{titleRadioMultipleItemList}</Radio>
                      </RadioGroup >
                    </div>
                  }
                </div>
              }
            </div>
          }
        </Form>
      </TextStyle>
    );
  }
}
export const InstructionTaskComponent = Form.create()(TextIntructionComponent);

const DividerBorder = styled.div`
    margin-top: 3rem;    
    margin-bottom: 2rem;
    border-bottom: 1px solid ${Theme.secondary.midGrey};
`
const DividerSlimBorder = styled.div`
    margin-top: 2rem;    
    margin-bottom: 2rem;
    border-bottom: 1px solid ${Theme.secondary.midGrey};
`

const TextAreaStyle = styled.div`
    margin-top: 3rem;
    .form-style{
        padding-left: 100px;
        padding-right: 50px;
    }
    width: 100%;
    
    .textarea-style{
        width 100%;
    }
    .textarea-position{
        margin-top: -1rem;
    }
`

const TextStyle = styled.div`
    width: 100%;
    padding-top: 25px;
    padding-left: 50px;
    padding-right: 50px;
    .text-checkbox-validation{
      width:50%;
      margin-top: 1rem;
      margin-right: 3rem;
  }

    .content-conditions-task-components{
        margin-top:2rem;
    }
    .content-conditions-goto-components{
      margin-bottom:5px;
  }
    .radio-new-or-existing-style{
        margin-top: 2rem;

        .radio-item-style{
            margin-top: 1rem;
        }
    }

    .input-style{
        width 100%;
        margin-top: -1rem;
    }
    
    .description-aditional-text-style{
        margin-top: 1.2rem;
    }
    .example-text-style{
        margin-top: -2rem;
    }
    .count-input{
        margin-top: -10px;
        font-weight: bold;
        color: ${Theme.secondary.midGrey};
    }
    .count-input-red{
        margin-top: -10px;
        color: ${Theme.secondary.red};
        font-weight: bold;
    }
    @keyframes shake {
        10%, 90% {
          transform: translate3d(-1px, 0, 0);
        }
      
        20%, 80% {
          transform: translate3d(2px, 0, 0);
        }
      
        30%, 50%, 70% {
          transform: translate3d(-4px, 0, 0);
        }
      
        40%, 60% {
          transform: translate3d(4px, 0, 0);
        }
      }
      .apply-shake {
          animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
      }
`
